import { render, staticRenderFns } from "./VillagePlotOverlay.vue?vue&type=template&id=972c36c0&scoped=true&"
import script from "./VillagePlotOverlay.vue?vue&type=script&lang=js&"
export * from "./VillagePlotOverlay.vue?vue&type=script&lang=js&"
import style0 from "./VillagePlotOverlay.vue?vue&type=style&index=0&id=972c36c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972c36c0",
  null
  
)

export default component.exports